import {
  checkIfConstructionPlanningAvailable,
  getConstructionPlanPlayer,
} from '../gameState/construction/planning/getConstructionPlanContext';
import {selectTurnDisplayedPlayer} from '../gameState/supply/parallelSupplySelectors';

/**
 * Игрок, чьим цветом окрашен интерфейс хода: рамка (GreekBorder в шапке и
 * подвале) и отметка выбранного жетона в панели строений (cell-icon).
 *
 * Обычно это ходящий игрок. Исключение — планирование строительства в чужой
 * ход (см. getConstructionPlanContext): игрок размечает СВОЙ будущий ход, и
 * интерфейс носит его цвет, а не цвет того, кто ходит сейчас. Как только
 * собственный ход строительства завершен, планирование закрывается само, и
 * цвет снова становится цветом ходящего.
 *
 * В одновременной фазе снабжения сетевой игры «ходящий» — тот же игрок, что на
 * кнопке завершения хода и в стате шапки (selectTurnDisplayedPlayer): сам
 * пользователь, пока не закончил свою часть фазы, потом — первый еще не
 * закончивший. Вне этой фазы selectTurnDisplayedPlayer — текущий игрок.
 */
export const getTurnColorPlayer = (state) => (
  checkIfConstructionPlanningAvailable(state)
    ? getConstructionPlanPlayer(state)
    : selectTurnDisplayedPlayer(state)
);
